export default __webpack_public_path__ + "static/media/miansai.fe9fde52.png";